import type {TurnState} from '@wandb/weave/lib/WbAgent/WbAgentClient';
import React from 'react';

import {STATE_COLORS} from './constants';
import {ClockIcon} from './icons';
import {
  fmtDateGroup,
  fmtTime,
  STATE_LABELS,
  type useWbAgentChat,
} from './useWbAgentChat';

type Chat = ReturnType<typeof useWbAgentChat>;

export const HistoryTab: React.FC<{chat: Chat}> = ({chat}) => {
  if (chat.sessions.length === 0) {
    return (
      <div className="flex flex-1 flex-col items-center overflow-auto p-12 pt-48 text-[#8F949E]">
        <div className="text-[#D4D5D9]">
          <ClockIcon />
        </div>
        <p className="mt-8 text-[13px]">No conversations yet</p>
        <p className="max-w-[200px] text-[11px] text-[#B1B4B9]">
          Start a conversation and it will appear here
        </p>
      </div>
    );
  }

  let lastGroup = '';

  return (
    <div className="flex-1 overflow-auto p-12">
      {chat.sessions.map(session => {
        const isActive = session.root_turn_id === chat.rootTurnId;
        const group = fmtDateGroup(session.created_at);
        const showGroup = group !== lastGroup;
        lastGroup = group;
        const stateColor =
          STATE_COLORS[session.state as TurnState] ?? '#8F949E';
        const stateLabel =
          STATE_LABELS[session.state as TurnState] ?? session.state;
        return (
          <React.Fragment key={session.id}>
            {showGroup && (
              <p className="mb-6 mt-12 px-2 text-[10px] font-semibold uppercase tracking-[0.05em] text-[#8F949E] first:mt-0">
                {group}
              </p>
            )}
            <div
              onClick={() => chat.loadSession(session.root_turn_id)}
              className={`mb-6 cursor-pointer rounded-lg border p-10 transition-all duration-150 ${
                isActive
                  ? 'border-[#13A9BA] bg-[#f0fafb] hover:border-[#13A9BA] hover:bg-[#e5f6f8]'
                  : 'border-[#E8E8E9] bg-white hover:border-[#D4D5D9] hover:bg-[#F8F8F8]'
              }`}>
              <p
                className={`mb-4 truncate text-[13px] text-[#3F464F] ${
                  isActive ? 'font-medium' : 'font-normal'
                }`}>
                {session.user_prompt || '(empty)'}
              </p>
              <div className="flex items-center gap-6">
                <div className="flex items-center gap-[3px]">
                  <span
                    className="inline-block h-[5px] w-[5px] shrink-0 rounded-full"
                    style={{backgroundColor: stateColor}}
                  />
                  <span
                    className="text-[10px] font-medium"
                    style={{color: stateColor}}>
                    {stateLabel}
                  </span>
                </div>
                <span className="text-[10px] text-[#B1B4B9]">
                  {fmtTime(session.created_at)}
                </span>
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};
